import _JSXStyle from "styled-jsx/style";
import React from 'react';
import useTheme from '../styles/use-theme';

var InputBlockLabel = function InputBlockLabel(_ref) {
  var children = _ref.children;
  var theme = useTheme();
  return (
    /*#__PURE__*/
    React.createElement("label", {
      className: _JSXStyle.dynamic([["713096549", [theme.palette.accents_6, theme.layout.gapHalf]]])
    }, children,
    /*#__PURE__*/
    React.createElement(_JSXStyle, {
      id: "713096549",
      dynamic: [theme.palette.accents_6, theme.layout.gapHalf]
    }, "label.__jsx-style-dynamic-selector{display:block;font-weight:normal;color:".concat(theme.palette.accents_6, ";padding:0 0 0 1px;margin-bottom:").concat(theme.layout.gapHalf, ";font-size:1rem;line-height:1.5;}label.__jsx-style-dynamic-selector>*:first-child{margin-top:0;}label.__jsx-style-dynamic-selector>*:last-child{margin-bottom:0;}")))
  );
};

var MemoInputBlockLabel =
/*#__PURE__*/
React.memo(InputBlockLabel);
export default MemoInputBlockLabel;